export default "__VITE_ASSET__DbrRH6B5__"